import { createFileRoute } from "@tanstack/react-router";

import ReportSettings from "/src/routes/settings/General/report/ReportSettings";

export const Route = createFileRoute("/_main/settings/report")({
  component: ReportSettings,
});
